import axios from '../axios'
import Cookies from "js-cookie"
/* 
 * 附件信息管理
 */

/**
 * 批量删除附件信息
 * @param {*} service   服务模块 例：admin
 * @param {*} data 
 * @returns 
 */
export const accessoryBatchDelete = (service, data) => {
    return axios({
        url: '/' + service + '/api/accessory/accessoryBatchDelete',
        method: 'post',
        data
    })
}

/**
 * 上传并解析附件信息
 * @param {*} service   服务模块 例：admin
 * @param {*} data 
 * @returns 
 */
export const uploadAndParse = (dir, service, data) => {
    var formData = new FormData();
    formData.append('dir',  dir + '/' + service + '/');
    formData.append('file', data.file);
    formData.append('fileRemark', data.fileRemark);
    
    return axios({
        url: "/" + service + "/api/accessory/uploadAndParse",
        headers: { 'content-type': 'multipart/form-data' },
        method: "post",
        data: formData
    })
}

export const taobaoImport = (service, fileName) => {
    var formData = new FormData();
    formData.append('operator',  Cookies.get('user'));
    formData.append('file', fileName);

    return axios({
        url: "/" + service + "/syncRecord/taobaoImport",
        headers: { 'content-type': 'multipart/form-data' },
        method: "post",
        data: formData
    })
}

/**
 * 查询附件信息列表
 * @param {*} service   服务模块 例：admin
 * @param {*} params    请求参数
 * @returns 
 */
export const selectAccessory = (service, params) => {
    return axios({
        url: "/" + service + "/api/accessory/selectAccessory",
        method: "get",
        params
    })
}

/**
 * 批量上传并解析附件信息（未联调成功）
 * @param {*} service   服务模块 例：admin
 * @param {*} data    请求参数
 * @returns 
 */
 export const batchInsert = (service, data) => {
    return axios({
        url: "/" + service + "/api/accessory/batchInsert",
        method: "post",
        data,
    })
}


// WEBPACK FOOTER //
// ./src/http/moudules/accessory.js